import React from 'react';
import { SvgType } from '../svgType';

export default ({ className }: SvgType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 100 125"
    xmlSpace="preserve"
    className={className}
  >
    <path d="M83.1,32.9c-0.3-2.7-2.5-4.7-5.1-4.7h-7.8V28C69.9,16.9,61.1,8.2,50.1,8.2c-10.9,0-20,8.9-20.3,19.9v0.1H22  c-2.7,0-4.9,2-5.2,4.8L14,86.1c-0.1,1.4,0.4,2.8,1.4,3.9c1,1.1,2.4,1.7,3.8,1.7h61.8c1.5,0,2.9-0.6,3.9-1.7c1-1.1,1.4-2.5,1.3-3.8  L83.1,32.9z M50.1,14.5c7.2,0,13,5.4,13.8,12.4H36.2C37,20,42.9,14.5,50.1,14.5z" />
  </svg>
);
